// @flow

import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';

export default class ActivationKeyModal extends Component {
    render() {
        const { show, handleClose, activationKey } = this.props;
        return (
            <Modal
                animation={false}
                show={show}
                onHide={handleClose}
                className="modal"
                dialogClassName="modal-lg modal-dialog-centered"
            >
                <Modal.Header closeButton>
                    <Modal.Title className="fw-400 fs-14">Chave de Ativação</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-0">
                    <div className="alert alert-danger rounded-0 mb-0">Insira a chave abaixo para ativar o terminal.</div>
                    <pre className="text-center py-4 text-white bg-dark">{activationKey}</pre>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-danger btn-outline" onClick={handleClose}>Fechar</button>
                </Modal.Footer>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Pages/Terminals/ActivationKeyModal.js